import styled from 'styled-components';
import React from 'react';
import { Grid, Header } from 'semantic-ui-react';
import DOMPurify from 'dompurify';
import Parser from 'html-react-parser';
import { breakpoints, verticalGutter } from '../../styles';
import { GridNumbers } from '../../utils';
import { Badge, CTA, ModuleContainer } from '../../components';
import { withAnalytics } from '../../analytics';
import PropTypes from 'prop-types';

const StyledBottomPromos = styled(Grid.Column)`
  order: ${({ order }) => (order && order === 'right' ? 2 : 1)};
  .ui.grid {
    height: calc(100% + ${verticalGutter}rem);
  }

  /* namespaced styles */
  .bottom-promos {
    &__img {
      position: relative;
      margin: 0 0 -${verticalGutter}rem;
      width: 100%;
      height: 0;
      padding-bottom: ${(3 / 4) * 100}%;
      &:before {
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: ${({ background }) =>
          `url(${background}) no-repeat center center`};
        background-size: cover;
      }
      @media screen and (min-width: ${breakpoints.tablet}) {
        margin-bottom: 0;
        padding-bottom: 0;
        height: 100%;
      }
    }

    &__body {
      padding: ${verticalGutter * 0.75}rem;
      > * {
        align-self: flex-start;
      }
      @media screen and (min-width: ${breakpoints.tablet}) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        padding: ${verticalGutter}rem;
        padding-left: 0;
        /* random number 380 from design */
        min-height: 380px;
      }
    }
  }
`;

const BottomPromos = ({ data: promos, analytics }) => {
  const renderCtaLink = promo => {
    const type = promo.ctaType && promo.ctaType.toLowerCase();

    const onCtaClick = () => {
      analytics.trackEvent('Bottom Promo', {
        url: promo.ctaLink,
        title: promo.title
      });
    };

    return type === 'button' ? (
      <CTA link={promo.ctaLink} onClick={onCtaClick} flex>
        {promo.ctaText}
      </CTA>
    ) : (
      <a href={promo.ctaLink} onClick={onCtaClick} target="_blank">
        {promo.ctaText}
      </a>
    );
  };

  const renderPropmo = promo => (
    <StyledBottomPromos
      key={promo.title}
      mobile={GridNumbers.base}
      largeScreen={GridNumbers.half}
      widescreen={GridNumbers.half}
      order={promo.alignment.toLowerCase()}
      background={promo.mobileBackground || promo.backgroundImage}
    >
      <ModuleContainer fill>
        <Grid>
          <Grid.Column
            mobile={GridNumbers.base}
            tablet={GridNumbers.half}
            computer={GridNumbers.half}
          >
            <figure className="bottom-promos__img">
              {promo.bannerText && (
                <Badge as="figcaption" className="text--upper">
                  {promo.bannerText}
                </Badge>
              )}
            </figure>
          </Grid.Column>
          <Grid.Column
            as="article"
            mobile={GridNumbers.base}
            tablet={GridNumbers.half}
            computer={GridNumbers.half}
          >
            <div className="bottom-promos__body">
              <Header as="h3">{promo.title}</Header>
              {Parser(DOMPurify.sanitize(promo.body))}
              {renderCtaLink(promo)}
            </div>
          </Grid.Column>
        </Grid>
      </ModuleContainer>
    </StyledBottomPromos>
  );

  return <Grid columns={2}>{promos.map(renderPropmo)}</Grid>;
};

BottomPromos.propTypes = {
  analytics: PropTypes.object,
  data: PropTypes.array
};

export default withAnalytics(BottomPromos);



// WEBPACK FOOTER //
// ./src/pages/Landing/BottomPromos.js